import {SET_VIDEOS, REMOVE_VIDEO, LOADIND_VIDEOS, SET_ERROR, REMOVE_VIDEO_REQUEST, LOAD_VIDEOS_REQUEST, UPLOAD_VIDEO_REQUEST} from "./types";

export function getVideos() {
    return {
        type: LOAD_VIDEOS_REQUEST,
    };
}

export function removeVideoRequest(payload) {
    return {
        type: REMOVE_VIDEO_REQUEST,
        payload
    };
}

export function uploadVideo(payload) {
    return {
        type: UPLOAD_VIDEO_REQUEST,
        payload
    };
}

export function setVideos(videos) {
    return {
        type: SET_VIDEOS,
        videos,
    };
}

export function removeVideo(id) {
    return {
        type: REMOVE_VIDEO,
        id
    };
}

export function setLoading(isFetching) {
    return {
        type: LOADIND_VIDEOS,
        isFetching
    };
}

export function setError(isError) {
    return {
        type: SET_ERROR,
        isError,
    };
}
